import { PascalToCamel } from "./types/PascalToCamel";
import { fromPascalToCamel } from "./FromPascalToCamel.function";

export const withCamelResponse = <T, R>(modifier: (data: PascalToCamel<T>) => R): ((response: Response) => Promise<R>) => {
    return async (response: Response): Promise<R> => modifier(await fromPascalToCamel(response));
};
